import { ofType, combineEpics } from 'redux-observable';
import { actionCreators } from '../actions/globalAction';
import { map, mergeMap, filter, scan, take, toArray, switchMap, withLatestFrom } from 'rxjs/operators';

export const showLoader = (actions$, state$) =>
    actions$.pipe(
        ofType("showLoader"),
        withLatestFrom(state$),
        //.pipe(
            //map(state => Object.assign({}, state, { hallo: state.count + 1 }))    
        mergeMap(([action, state]) => new Promise(resolve => {
            //debugger;
            //var a = action.type;
            //var b = state;
            resolve({ name: 'Max' });
        })
        //    .pipe(
        //    map(response => fetchUserFulfilled(response))
        //)
            
            //ajax.getJSON(`https://api.github.com/users/${action.payload.username}`)
            //    .map(user => fetchUserSuccess(user))
            //    .takeUntil(actions$.ofType(FETCH_USER))
            //    .retry(2)
            //    .catch(error => Observable.of(fetchUserFailed()))
        )
    );


export default combineEpics(
    showLoader
);